/* eslint-disable indent */
import api from '@Config/api';
import { callApi } from '../middleware/request'
// import { store } from '../redux.store'

async function callGraphql(sql: string, variables: string, method = 'POST') {
  return callApi({
    domain: api().API_BASE_HOST,
    method,
    pathUrl: '/graphql',
    body: {
      query: `${sql}`,
      variables: variables || null,
    },
  })
}

export const getListEClinic = (args) => {
  return callGraphql(`query Query($sort: eClinicSort, $limit: PageLimitInput, $displayName: String, $medicalSpecialties: [String]) {
        eClinics(sort: $sort, limit: $limit, displayName: $displayName, medicalSpecialties: $medicalSpecialties) {
          eClinicId
          avatar
          description
          displayName
          doctor { 
            degree { degreeId name shortName } 
            medicalSpecialties { medicalSpecialtyId name }
            partner { partnerId name }
            fullName 
          }
          slug
        }
      }`, { ...args })
}

export const getUltilities = (args) => {
  return callGraphql(`query getUtility{
        utilities {
          relations {
            label
            value
          }
        }
      }`, { ...args })
}

export function getMedicalSpecialities(args) {
  return callGraphql(`query Query($medicalSpecialtyId: String, $partnerId: String, $limit: PageLimitInput, $sort: MedicalSpecialitySort) {
    medicalSpecialities(medicalSpecialtyId: $medicalSpecialtyId, partnerId: $partnerId, limit: $limit, sort: $sort) {
      medicalSpecialtyId
      name
    }
  }`, { ...args })
}

export function getPartner(args) {
  return callGraphql(`query Query($partnerId: String, $limit: PageLimitInput, $sort: DegreeSort) {
    partners(partnerId: $partnerId, limit: $limit, sort: $sort) {
      partnerId
      name
    }
  }`, { ...args })
}

export function getDegrees(args) {
  return callGraphql(`query Query($degreeId: String, $partnerId: String, $limit: PageLimitInput, $sort: DegreeSort) {
    degrees(degreeId: $degreeId, partnerId: $partnerId, limit: $limit, sort: $sort) {
      degreeId
      shortName
      name
    }
  }`, { ...args })
}
